<template>
  <GMapMap
    style="width: 100%; height: 350px"
    :center="center"
    :zoom="6.7"
    :options="{
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: true,
      streetViewControl: false,
      rotateControl: true,
      fullscreenControl: true,
    }"
  >
    <GMapMarker
      v-for="(location, index) in locations"
      :key="index"
      :options="{ position: location.position }"
      @click="selectedLocation = location.name"
      :icon="{
        url: require('@/assets/img/icon_map.png'),
        scaledSize: { width: 25, height: 40 },
      }"
    >
      <GMapInfoWindow :opened="selectedLocation === location.name">
        <div>
          <div style="margin-bottom: 10px">
            <b>{{ location.name }}</b>
          </div>
          <ion-button size="small" @click="emitValue()" target="_blank"
            >Termin buchen</ion-button
          >
          <br />
          <ion-button
            size="small"
            fill="outline"
            :href="'tel:' + location.tel.replace('(0)', '')"
            target="_blank"
            v-if="location.tel"
            >{{
              location.tel.replace("+49(0)", "0").replaceAll("-", " ")
            }}</ion-button
          >
          <br />
          <ion-button
            size="small"
            fill="outline"
            :href="
              'https://www.google.com/maps/dir/?api=1&destination=' +
              location.position.lat +
              ',' +
              location.position.lng
            "
            target="_blank"
            >Route planen</ion-button
          >
        </div>
      </GMapInfoWindow>
    </GMapMarker>
  </GMapMap>
  <ion-item class="ion-margin-vertical">
    <ion-label>Standort</ion-label>
    <ion-select
      placeholder="Bitte wählen"
      v-model="selectedLocation"
      cancel-text="Abbrechen"
    >
      <ion-select-option
        v-for="(location, index) in locations"
        :key="index"
        :value="location.name"
        >{{ location.name }}</ion-select-option
      >
    </ion-select>
  </ion-item>
  <next-question-button
    @click="emitValue()"
    :disabled="selectedLocation === ''"
  />
</template>

<script>
import NextQuestionButton from "./NextQuestionButton";
// import { GoogleMap, Marker } from "vue3-google-map";
import {
  IonItem,
  IonLabel,
  IonSelect,
  IonSelectOption,
  IonButton,
} from "@ionic/vue";
import { Geolocation } from "@capacitor/geolocation";
import { ztkLocations } from "@arag/utils/basics";

export default {
  emits: ["done"],
  components: {
    NextQuestionButton,
    // GoogleMap,
    // Marker,
    IonItem,
    IonLabel,
    IonSelect,
    IonSelectOption,
    IonButton,
  },
  props: {
    question: {
      required: true,
      type: Object,
    },
  },
  async mounted() {
    const coordinates = await Geolocation.getCurrentPosition();
    console.log("Current", coordinates);
    let nearestLocation = { name: "", distance: 0 };
    for (const location of this.locations) {
      const distance = this.distance(
        coordinates.coords.latitude,
        coordinates.coords.longitude,
        location.position.lat,
        location.position.lng,
        "K"
      );
      if (
        nearestLocation.distance === 0 ||
        nearestLocation.distance > distance
      ) {
        nearestLocation = { name: location.name, distance: distance };
      }
    }
    this.selectedLocation = nearestLocation.name;
  },
  data() {
    return {
      search: "",
      center: { lat: 49.0422994, lng: 10.2650204 },
      selectedLocation: "",
      locations: ztkLocations,
    };
  },
  methods: {
    emitValue() {
      this.$emit("done", {
        value: this.selectedLocation,
        valueIds: this.locations.find(
          (location) => location.name === this.selectedLocation
        ),
        id: this.question.id,
      });
    },
    distance(lat1, lon1, lat2, lon2, unit) {
      var radlat1 = (Math.PI * lat1) / 180;
      var radlat2 = (Math.PI * lat2) / 180;
      var theta = lon1 - lon2;
      var radtheta = (Math.PI * theta) / 180;
      var dist =
        Math.sin(radlat1) * Math.sin(radlat2) +
        Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
      if (dist > 1) {
        dist = 1;
      }
      dist = Math.acos(dist);
      dist = (dist * 180) / Math.PI;
      dist = dist * 60 * 1.1515;
      if (unit == "K") {
        dist = dist * 1.609344;
      }
      if (unit == "N") {
        dist = dist * 0.8684;
      }
      return dist;
    },
  },
};
</script>

<style lang="scss">
.gm-style .gm-style-iw-c {
  padding: 12px !important;
}
</style>
